import { createMongoAbility } from '@casl/ability'

export type Actions = 'create' | 'read' | 'update' | 'delete' | 'manage'

// 프로젝트 리소스 정의
export type Subjects =
  | 'Auth'
  | 'Dashboard'
  | 'Review'
  | 'Client'
  | 'DriverConfig'
  | 'Upload'
  | 'MeetingRoom'
  | 'Admin'
  | 'all'

export interface Rule { action: Actions; subject: Subjects }

// 초기 권한 (로그인하지 않은 사용자)
export const initialAbility: Rule[] = [
  { action: 'read', subject: 'Auth' },
]

// localStorage에서 권한 로드
const loadAbilityFromStorage = (): Rule[] => {
  const userDataStr = localStorage.getItem('userData')
  if (userDataStr) {
    try {
      const userData = JSON.parse(userDataStr)
      if (userData?.ability && Array.isArray(userData.ability))
        return userData.ability
    }
    catch (e) {
      console.warn('Failed to parse user ability from localStorage', e)
    }
  }

  return initialAbility
}

export const ability = createMongoAbility<[Actions, Subjects]>(loadAbilityFromStorage())
